// SEO landing page content for service-type and brand pages.

export const SERVICES = [
  {
    slug: "led-tv-repair-in-bangalore",
    name: "LED TV Repair",
    blurb:
      "From dim or dead backlights to blank screens and stubborn standby lights, our engineers diagnose every LED television fault down to the board and put it right the same day.",
    faults: [
      "Sound works but the screen stays black (backlight failure)",
      "TV won't switch on or is stuck on the standby light",
      "Dark patches, shadows or uneven brightness",
      "Flickering, dimming or pulsing picture",
      "Vertical or horizontal lines across the display",
    ],
  },
  {
    slug: "lcd-tv-repair-in-bangalore",
    name: "LCD TV Repair",
    blurb:
      "Washed-out colours, ghosting, dead pixels or crackly audio on your LCD panel? We restore crisp picture and clean sound with quality parts and careful workmanship.",
    faults: [
      "Faded, discoloured or yellow-tinted picture",
      "Dead pixels or persistent image retention",
      "No display with audio still working",
      "Distorted, muffled or missing sound",
      "Screen flicker or intermittent blackouts",
    ],
  },
  {
    slug: "oled-tv-repair-in-bangalore",
    name: "OLED TV Repair",
    blurb:
      "OLED sets demand a delicate touch. Our specialists handle burn-in, panel faults and mainboard issues on premium OLED televisions with the precision they deserve.",
    faults: [
      "Burn-in or image retention marks",
      "Half-screen dimming or colour shift",
      "Panel cracks or pressure damage",
      "Mainboard or T-CON board failure",
      "Sudden black screen on power-up",
    ],
  },
  {
    slug: "qled-tv-repair-in-bangalore",
    name: "QLED TV Repair",
    blurb:
      "We service QLED displays of every size, tackling backlight, panel and processing faults so your quantum-dot picture looks as vivid as the day you bought it.",
    faults: [
      "Dark zones or backlight bleed",
      "Colour banding or washed-out tones",
      "Blank screen with working sound",
      "Power board clicking or restarts",
      "HDMI input not detected",
    ],
  },
  {
    slug: "smart-tv-repair-in-bangalore",
    name: "Smart TV Repair",
    blurb:
      "Frozen menus, crashing apps, sluggish performance or Wi-Fi dropouts? We sort software gremlins and hardware faults on every smart-TV platform.",
    faults: [
      "Apps crashing or refusing to load",
      "Frozen, laggy or unresponsive menus",
      "Wi-Fi or Bluetooth keeps disconnecting",
      "Software stuck on boot or update loop",
      "Casting and screen-mirroring failures",
    ],
  },
  {
    slug: "android-tv-repair-in-bangalore",
    name: "Android TV Repair",
    blurb:
      "Android TV acting up? We fix update loops, storage errors, remote pairing trouble and connectivity issues to get your smart features flowing again.",
    faults: [
      "Stuck on the boot or update screen",
      "Insufficient storage or app errors",
      "Voice remote won't pair",
      "Google account or Play Store issues",
      "Audio-video sync problems",
    ],
  },
  {
    slug: "4k-uhd-tv-repair-in-bangalore",
    name: "4K & UHD TV Repair",
    blurb:
      "HDMI handshake errors, image-processor faults and resolution glitches on high-end 4K and UHD screens are everyday work for our bench-trained engineers.",
    faults: [
      "No 4K signal or wrong resolution output",
      "HDMI handshake or HDCP errors",
      "Image processor artefacts or stutter",
      "Screen tearing on fast motion",
      "Panel or backlight faults",
    ],
  },
  {
    slug: "plasma-tv-repair-in-bangalore",
    name: "Plasma TV Repair",
    blurb:
      "Still love your plasma set? We breathe new life into older displays, fixing power-board trouble, buzzing and panel glitches with care.",
    faults: [
      "TV won't power on or clicks repeatedly",
      "Buzzing or humming noise",
      "Image burn-in or screen flicker",
      "Sustain or buffer board faults",
      "Half-screen colour issues",
    ],
  },
  {
    slug: "tv-screen-replacement-in-bangalore",
    name: "TV Screen Replacement",
    blurb:
      "A cracked or shattered panel doesn't have to mean a new TV. We assess, source and fit replacement screens wherever it's the smart, cost-effective choice.",
    faults: [
      "Cracked, shattered or impacted screen",
      "Spider-web cracks under the glass",
      "Liquid or ink-like spreading marks",
      "Pressure spots or internal bruising",
      "Screen separation from the frame",
    ],
  },
  {
    slug: "tv-motherboard-repair-in-bangalore",
    name: "TV Motherboard Repair",
    blurb:
      "The mainboard is your TV's brain. We perform component-level diagnosis and repair on main and power boards to revive sets others call write-offs.",
    faults: [
      "Dead set with no standby light",
      "Random restarts or shutdowns",
      "No picture, no sound, no response",
      "Inputs or smart features not working",
      "Power board or capacitor failure",
    ],
  },
  {
    slug: "tv-backlight-repair-in-bangalore",
    name: "TV Backlight Repair",
    blurb:
      "If you can hear the show but the screen is dark, the backlight is usually to blame. We replace LED strips and drivers to bring the picture back.",
    faults: [
      "Black screen with working sound",
      "Faint image visible under torchlight",
      "Uneven brightness or dark bands",
      "Backlight flickers then cuts out",
      "Failed LED strips or driver board",
    ],
  },
  {
    slug: "tv-wall-mounting-installation-in-bangalore",
    name: "TV Installation & Wall Mounting",
    blurb:
      "New TV or shifting home? We handle safe wall mounting, bracket fitting and full setup so your screen sits perfectly and works flawlessly from day one.",
    faults: [
      "Fixed and tilt wall-mount fitting",
      "Cable management and concealment",
      "First-time setup and tuning",
      "Soundbar and device connection",
      "Safe de-install and re-install on shifting",
    ],
  },
];

export const BRANDS = [
  { slug: "lg-tv-repair-in-bangalore", name: "LG TV Repair & Service", brand: "LG" },
  { slug: "samsung-tv-repair-in-bangalore", name: "Samsung TV Repair & Service", brand: "Samsung" },
  { slug: "sony-tv-repair-in-bangalore", name: "Sony TV Repair & Service", brand: "Sony" },
  { slug: "tcl-tv-repair-in-bangalore", name: "TCL TV Repair & Service", brand: "TCL" },
  { slug: "mi-xiaomi-tv-repair-in-bangalore", name: "Mi / Xiaomi TV Repair & Service", brand: "Mi / Xiaomi" },
  { slug: "oneplus-tv-repair-in-bangalore", name: "OnePlus TV Repair & Service", brand: "OnePlus" },
  { slug: "vu-tv-repair-in-bangalore", name: "Vu TV Repair & Service", brand: "Vu" },
  { slug: "panasonic-tv-repair-in-bangalore", name: "Panasonic TV Repair & Service", brand: "Panasonic" },
  { slug: "hisense-tv-repair-in-bangalore", name: "Hisense TV Repair & Service", brand: "Hisense" },
  { slug: "toshiba-tv-repair-in-bangalore", name: "Toshiba TV Repair & Service", brand: "Toshiba" },
  { slug: "philips-tv-repair-in-bangalore", name: "Philips TV Repair & Service", brand: "Philips" },
  { slug: "sansui-tv-repair-in-bangalore", name: "Sansui TV Repair & Service", brand: "Sansui" },
  { slug: "bpl-tv-repair-in-bangalore", name: "BPL TV Repair & Service", brand: "BPL" },
  { slug: "onida-tv-repair-in-bangalore", name: "Onida TV Repair & Service", brand: "Onida" },
  { slug: "videocon-tv-repair-in-bangalore", name: "Videocon TV Repair & Service", brand: "Videocon" },
  { slug: "haier-tv-repair-in-bangalore", name: "Haier TV Repair & Service", brand: "Haier" },
  { slug: "realme-tv-repair-in-bangalore", name: "Realme TV Repair & Service", brand: "Realme" },
  { slug: "thomson-tv-repair-in-bangalore", name: "Thomson TV Repair & Service", brand: "Thomson" },
  { slug: "kodak-tv-repair-in-bangalore", name: "Kodak TV Repair & Service", brand: "Kodak" },
  { slug: "micromax-tv-repair-in-bangalore", name: "Micromax TV Repair & Service", brand: "Micromax" },
  { slug: "akai-tv-repair-in-bangalore", name: "Akai TV Repair & Service", brand: "Akai" },
  { slug: "sanyo-tv-repair-in-bangalore", name: "Sanyo TV Repair & Service", brand: "Sanyo" },
  { slug: "lloyd-tv-repair-in-bangalore", name: "Lloyd TV Repair & Service", brand: "Lloyd" },
  { slug: "intex-tv-repair-in-bangalore", name: "Intex TV Repair & Service", brand: "Intex" },
  { slug: "sharp-tv-repair-in-bangalore", name: "Sharp TV Repair & Service", brand: "Sharp" },
  { slug: "hyundai-tv-repair-in-bangalore", name: "Hyundai TV Repair & Service", brand: "Hyundai" },
];

// Top Bangalore neighbourhoods — hyper-local SEO landing pages.
export const LOCALITIES = [
  { slug: "tv-repair-in-koramangala", area: "Koramangala" },
  { slug: "tv-repair-in-indiranagar", area: "Indiranagar" },
  { slug: "tv-repair-in-hsr-layout", area: "HSR Layout" },
  { slug: "tv-repair-in-whitefield", area: "Whitefield" },
  { slug: "tv-repair-in-electronic-city", area: "Electronic City" },
  { slug: "tv-repair-in-marathahalli", area: "Marathahalli" },
  { slug: "tv-repair-in-btm-layout", area: "BTM Layout" },
  { slug: "tv-repair-in-jayanagar", area: "Jayanagar" },
  { slug: "tv-repair-in-jp-nagar", area: "JP Nagar" },
  { slug: "tv-repair-in-bellandur", area: "Bellandur" },
  { slug: "tv-repair-in-sarjapur-road", area: "Sarjapur Road" },
  { slug: "tv-repair-in-banashankari", area: "Banashankari" },
  { slug: "tv-repair-in-hebbal", area: "Hebbal" },
  { slug: "tv-repair-in-yelahanka", area: "Yelahanka" },
  { slug: "tv-repair-in-rajajinagar", area: "Rajajinagar" },
  { slug: "tv-repair-in-malleshwaram", area: "Malleshwaram" },
  { slug: "tv-repair-in-bannerghatta-road", area: "Bannerghatta Road" },
  { slug: "tv-repair-in-basavanagudi", area: "Basavanagudi" },
  { slug: "tv-repair-in-kalyan-nagar", area: "Kalyan Nagar" },
  { slug: "tv-repair-in-mahadevapura", area: "Mahadevapura" },
  { slug: "tv-repair-in-ramamurthy-nagar", area: "Ramamurthy Nagar" },
  { slug: "tv-repair-in-kadugodi", area: "Kadugodi" },
  { slug: "tv-repair-in-kr-puram", area: "KR Puram" },
  { slug: "tv-repair-in-rt-nagar", area: "RT Nagar" },
  { slug: "tv-repair-in-kengeri", area: "Kengeri" },
];

const BRAND_FAULTS = [
  "No picture with working sound",
  "TV won't power on or keeps restarting",
  "Backlight, panel or display faults",
  "Software, app and connectivity issues",
  "Sound, HDMI and port problems",
];

const LOCALITY_FAULTS = [
  "Same-day doorstep visits with a friendly, uniformed engineer",
  "Repairs finished on-site for most common faults",
  "Genuine spare parts sourced through trusted channels",
  "Every job backed by a six-month parts-and-labour promise",
  "A clear, fair price agreed on the phone before we arrive",
];

export function getEntry(slug) {
  const service = SERVICES.find((s) => s.slug === slug);
  if (service) return { ...service, type: "service" };
  const brand = BRANDS.find((b) => b.slug === slug);
  if (brand)
    return {
      ...brand,
      type: "brand",
      blurb: `We service every ${brand.brand} television model sold in India — LED, LCD, QLED, OLED and smart sets alike. Same-day doorstep visits, genuine spare parts and a fair price quoted before any work begins.`,
      faults: BRAND_FAULTS,
    };
  const locality = LOCALITIES.find((l) => l.slug === slug);
  if (locality)
    return {
      ...locality,
      type: "locality",
      name: `TV Repair in ${locality.area}`,
      blurb: `Doorstep TV repair for ${locality.area} homes and offices. Our engineers cover every street in the neighbourhood with same-day visits, genuine parts and a fair price agreed up front.`,
      faults: LOCALITY_FAULTS,
    };
  return null;
}
